import { createAction, props } from '@ngrx/store';

import {
  DocRenameRequest,
  DocumentDuplicateResponse,
  TreatmentDocCreateRequest,
  TreatmentDocUpdateRequest,
  WorkspaceItem,
  WorkspaceItemType,
  WorkspaceMoveRequest
} from '@primatoo-ms-organization';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import { UpdateDocResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpdateDocResponse';

// TREATMENT
export const createTreatment = createAction('[treatment] Create Treatment', props<{
  request: TreatmentDocCreateRequest
}>());
export const createTreatmentSuccess = createAction('[treatment] Create Treatment Success', props<{
  id: number,
  treatmentType: 'HOLDER' | 'RESPONSIBLE' | 'PROJECT' | 'SUB_RESPONSIBLE'
}>());

export const createTreatmentFailed = createAction('[treatment] Create Treatment Failed', props<{ error: string }>());

export const updateTreatment = createAction('[treatment] Update Treatment', props<{
  id: number,
  request: TreatmentDocUpdateRequest
}>());
export const updateTreatmentSuccess = createAction('[treatment] Update Treatment Success', props<{
  response: UpdateDocResponse
}>());
export const updateTreatmentFailed = createAction('[treatment] Update Treatment Failed', props<{ error: any }>());

export const renameTreatment = createAction('[folder] Rename Treatment', props<{
  id: number,
  request: DocRenameRequest
}>());
export const renameTreatmentSuccess = createAction('[folder] Rename Treatment Success', props<{ id: number }>());
export const renameTreatmentFailed = createAction('[folder] Rename Treatment Failed', props<{ error: any }>());

export const publishTreatmentWithConfirm = createAction('[treatment] Publish Treatment with confirm',
  props<{ docId: number, skipBack?: boolean, hideInfo?: boolean }>());
export const publishTreatment = createAction('[treatment] Publish Treatment',
  props<{ docId: number, skipBack?: boolean }>());
export const publishTreatmentSuccess = createAction('[treatment] Publish Treatment Success');
export const publishTreatmentFailed = createAction('[treatment] Publish Treatment Failed', props<{ error: any }>());

export const moveTreatment = createAction('[treatment] Move Treatment',
  props<{ id: number, workspaceMoveRequest: WorkspaceMoveRequest, workspaceItemType: WorkspaceItemType }>());
export const moveTreatmentSuccess = createAction('[treatment] Move Treatment Success', props<{
  item: WorkspaceItem
}>());
export const moveTreatmentFailed = createAction('[treatment] Move Treatment Failed', props<{ error: any }>());

export const duplicateTreatment = createAction('[treatment] Duplicate treatment', props<{
  id: number,
  request: TreatmentDocCreateRequest
}>());
export const duplicateTreatmentHolderToResponsible = createAction(
  '[treatment] Duplicate treatment holder to Responsible',
  props<{
    id: number;
    request: TreatmentDocCreateRequest;
  }>()
);
export const duplicateTreatmentSuccess = createAction('[treatment] Duplicate treatment success', props<{
  response: DocumentDuplicateResponse
}>());
export const duplicateTreatmentFailed = createAction('[treatment] Duplicate treatment failed', props<{ error: any }>());

export const deleteTreatment = createAction('[treatment] Delete Treatment', props<{ id: number }>());
export const deleteTreatmentSuccess = createAction('[treatment] Delete Treatment Success');
export const deleteTreatmentFailed = createAction('[treatment] Delete Treatment Failed', props<{ error: any }>());

// export const deleteTreatmentWithVersion = createAction('[treatment] Delete Treatment WithVersion', props<{ id: number, version: number }>());
// export const deleteTreatmentWithVersionSuccess = createAction('[treatment] Delete Treatment WithVersion Success');
// export const deleteTreatmentWithVersionFailed = createAction('[treatment] Delete Treatment WithVersion Failed', props<{ error: any }>());

export const reopenTreatmentWithConfirm = createAction('[treatment] Reopen Treatment with confirm', props<{
  id: number
}>());
export const reopenTreatment = createAction('[treatment] Reopen Treatment', props<{ id: number }>());
export const reopenTreatmentSuccess = createAction('[treatment] Reopen Treatment Success', props<{ id: number }>());
export const reopenTreatmentFailed = createAction('[treatment] Reopen Treatment Failed', props<{ error: any }>());

export const validateTreatmentWithConfirm = createAction('[treatment] Validate document with confirm',
  props<{ docId: number, skipBack?: boolean }>());
export const validateTreatment = createAction('[treatment] Validate document'
  , props<{ docId: number, request: ValidateDocumentRequest, skipBack?: boolean }>());
export const validateTreatmentSuccess = createAction('[treatment] Validate document Success');
export const validateTreatmentFailed = createAction('[treatment] Validate document Failed', props<{ error: any }>());

export const createSnapshotSuccess = createAction('[treatment] Create Snapshot Success');
